import { Component, Input, OnInit } from '@angular/core';
import { LookupService } from '../../services/lookup.service';
import { ToastrService } from 'ngx-toastr';
import { CaseService } from '../../services/case.service';
import { SharedHttpService } from '../../services/shared-http.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { NotificationService } from '../../services/notification.service';
@Component({
  selector: 'app-case-categories', 
  templateUrl: './case-categories.component.html',
  styleUrls: ['./case-categories.component.scss']
})
export class CaseCategoriesComponent implements OnInit {
  casecategoriesArr: any;
  casecategoryId: any;
  @Input() eCaseId: any;
  @Input() modal: any;


  constructor(private tostar: NotificationService,public lookupService: LookupService,private modalService: NgbModal,public route: Router,private sharedService: SharedHttpService, public caseService: CaseService, public toastr: ToastrService) { }

  ngOnInit(): void {
    this.loadDate();
  }
  loadDate() {
    this.casecategoriesArr = this.lookupService.getLockup('casecategories');

  }

  AddChangeCaseCategory() {
    let obj = {
        "eCaseId": this.eCaseId,
        "categoryId": this.casecategoryId
    }
    this.sharedService.post(`api/Case/ChangeCaseCategory`, obj).subscribe(res => {
        this.modalService.dismissAll();
        if (res.isSuccess == true) {
            this.sharedService.showSuccessKey("SavedSuccessfully");
            this.route.navigateByUrl('/refresh', { skipLocationChange: true }).then(() => {
                this.route.navigate([`details/case/${this.eCaseId}/cases`]);
            });
        }
        else {
            this.tostar.showError(res.statusDescription, "");
        }
    });
}
}
